export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.narrativebench.mobile';

const PLAY_STORE_BADGE_LOCALES = new Set(['en', 'es', 'de', 'fr']);

export function getPlayStoreBadgeUrl(locale: string): string {
  const badgeLocale = locale === 'ca' ? 'es' : PLAY_STORE_BADGE_LOCALES.has(locale) ? locale : 'en';
  return `https://play.google.com/intl/${badgeLocale}_us/badges/static/images/badges/${badgeLocale}_badge_web_generic.png`;
}
